import React from 'react';
import { Table, TableProps, Tr, Td } from '@kizi/core-components';
import { TableAccordionRow } from './TableAccordionRow';
export interface ComparisonTableProps extends TableProps {
  rows: any[];
  options: string[];
}

export const ComparisonTable: React.FC<ComparisonTableProps> = ({
  rows,
  options,
  ...restProps
}) => {
  return (
    <Table variant="comparisonContainer" {...restProps}>
      <tbody>
        {rows?.map((row, j: number) => {
          if (row.hasOwnProperty('labels')) {
            return (
              <TableAccordionRow
                options={options}
                labels={row.labels}
                rows={row.rows}
              />
            );
          } else {
            return (
              <>
                {Array.isArray(row) && (
                  <Tr key={`row-${j}`} variant="comparisonTableRow">
                    {row?.map((cell: React.ReactNode, k: number) => {
                      return (
                        <Td key={`cell-${j}-${k}`} id={`comparison-td-${k}`}>
                          {cell}
                        </Td>
                      );
                    })}
                  </Tr>
                )}
              </>
            );
          }
        })}
      </tbody>
    </Table>
  );
};
